import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DropdownEffects } from './+state/dropdowns.effects';
import { crmDropdownsReducer } from './+state/dropdowns.reducer';
import { DropdownsStateService } from './+state/dropdowns-state.service';
import { AssociateClassesEffects } from './+state/associate-classes/associate-classes.effects';
import { HtmlMappingTemplatesEffects } from './+state/html-mapping-templates/html-mapping-templates.effects';
import { DirectMessageTemplatesEffects } from './+state/direct-message-templates/direct-message-templates.effects';
import { RooftopsEffects } from './+state/rooftops/rooftops.effects';
import { VehicleCategoriesEffects } from './+state/vehicle-categories/vehicle-categories.effects';
import { VehicleColoursEffects } from './+state/vehicle-colours/vehicle-colours.effects';
import { VehicleGenericModelsEffects } from './+state/vehicle-generic-models/vehicle-generic-models.effects';
import { VehicleMakesEffects } from './+state/vehicle-makes/vehicle-makes.effects';
import { VehicleStatusesEffects } from './+state/vehicle-statuses/vehicle-statuses.effects';
import { VehicleSubcategoriesEffects } from './+state/vehicle-subcategories/vehicle-subcategories.effects';
import { VehicleSubTypesEffects } from './+state/vehicle-subtypes/vehicle-subtypes.effects';
import { EmployeesEffects } from './+state/employees/employees.effects';
import { DeclinedReasonsEffects } from './+state/declined-reasons/declined-reasons.effects';
import { ActionTypesEffects } from './+state/action-types/action-types.effects';
// eslint-disable-next-line max-len
import { ServiceGroupSubCategoriesEffects } from './+state/service-group-sub-categories/service-group-sub-categories.effects';
import { ServiceGroupCategoriesEffects } from './+state/service-group-categories/service-group-categories.effects';
@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('svcDropdowns', crmDropdownsReducer),
    EffectsModule.forFeature([
      DropdownEffects,
      AssociateClassesEffects,
      DeclinedReasonsEffects,
      DirectMessageTemplatesEffects,
      HtmlMappingTemplatesEffects,
      RooftopsEffects,
      ServiceGroupCategoriesEffects,
      ServiceGroupSubCategoriesEffects,
      VehicleCategoriesEffects,
      VehicleColoursEffects,
      VehicleGenericModelsEffects,
      VehicleMakesEffects,
      VehicleStatusesEffects,
      VehicleSubcategoriesEffects,
      VehicleSubTypesEffects,
      EmployeesEffects,
      ActionTypesEffects
    ])
  ],
  providers: [DropdownsStateService]
})
export class SvcDropdownsModule {}
